import { Component } from '@angular/core';

@Component({
    selector: 'app-employee-planning-help',
    templateUrl: './employee-planning-help.component.html',
    standalone: false,
})
export class EmployeePlanningHelpComponent {
    readonly items: {
        icon: string;
        title: string;
        lines: string[];
    }[] = [
        {
            icon: 'fa-table-list',
            title: 'Weektotalen',
            lines: [
                'In de eerste kolom naast de medewerkers zie je een overzicht van de hele week.',
                'Het eerste getal geeft weer op hoeveel dagen in deze week de medewerker is ingepland. Dit is rood bij minder dan 5 dagen.',
                'Klik met de rechtermuisknop op een van de weekdagen om direct verlof toe te kennen of om de details van een dag te bekijken.',
            ],
        },
        {
            icon: 'fa-mouse',
            title: 'Medewerkers inplannen',
            lines: [
                'Schuif met de muis in de kolom van het gewenste project en uitvoerder over de rij van de medewerker die je wilt inplannen.',
                'Klik op een dag zonder kruisje om een medewerker op die dag in te plannen voor het project en met de uitvoerder van de kolom waar je in zit.',
                'Op dagen met een wit kruisje is de medewerker ingepland op een ander project.',
            ],
        },
        {
            icon: 'fa-trash-arrow-up',
            title: 'Verwijderen en ongedaan maken',
            lines: [
                'Klik op een gevuld vakje om een gewone personeelsplanning weer te verwijderen.',
                'Met de knop <i class="fa-solid fa-rotate-left"></i> (terugdraaien) worden nog niet opgeslagen wijzigingen teruggedraaid.',
                'Bij een gekoppelde transport- of asfaltplanning kan in plaats daarvan de onderliggende planning worden geopend.',
            ],
        },
        {
            icon: 'fa-user-pen',
            title: 'Project / uitvoerder wijzigen of toevoegen',
            lines: [
                'Wijzig de uitvoerder voor alle geplande medewerkers via de dropdown onder het projectnummer, bovenin het scherm.',
                'Voeg een nieuwe kolom met een andere uitvoerder toe door op het plusje naast de uitvoerder van een project te klikken.',
                'Voeg een extra project toe via het plusje rechts onderin het scherm.',
            ],
        },
        {
            icon: 'fa-circle-half-stroke',
            title: 'Dag / nacht',
            lines: [
                'Vink bovenin het scherm "Nacht" aan om medewerkers in de nacht in te plannen.',
                'Medewerkers die in de nacht zijn ingepland worden met een zwarte achtergrond getoond.',
            ],
        },
        {
            icon: 'fa-triangle-exclamation',
            title: 'Rood',
            lines: [
                'Klik met de rechtermuisknop in de kolom "WEEK" op een vakje en kies "Details dag" om te zien waar deze medewerker is ingepland.',
                'Een rode planning betekent dat een medewerker meer dan één planning op dezelfde dag heeft.',
                'Een rood vakje met getal betekent dat de medewerker minder dan 5 dagen is ingepland voor de huidige week.',
            ],
        },
    ];
}
